import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-cash-solutions-v2.component.scss';
var FormItemBusinessCashSolutionsV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCashSolutionsV2, _super);
    function FormItemBusinessCashSolutionsV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessCashSolutionsV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-business-cash-solutions__button');
        // fields
        this.emailField = this.element.querySelector("input[name=email]");
        this.recipientField = this.element.querySelector("input[name=recipient]");
        this.isSBCustomer = Array.from(this.element.querySelectorAll("input[name=banking-with-standard-bank]"));
        this.cashSolutionsProvince = this.element.querySelector("select[name=province]");
        this.isSBCustomerValue = "";
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        if (this.cashSolutionsProvince) {
            this.updateCashSolutionsEmail();
        }
    };
    FormItemBusinessCashSolutionsV2.prototype.bindEvents = function () {
        var _this = this;
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            _this.businessCashSolutionsValidations();
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.isSBCustomer) {
            this.isSBCustomer.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.isSBCustomerValue = _radio.value;
                });
            });
        }
        if (this.cashSolutionsProvince) {
            this.cashSolutionsProvince.addEventListener("change", function (pEvent) {
                _this.updateCashSolutionsEmail();
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
            _this.resetForm();
        }, false);
    };
    FormItemBusinessCashSolutionsV2.prototype.updateCashSolutionsEmail = function () {
        if (this.recipientField) {
            this.emailField.value = "website@standardbank.co.za";
            switch (this.cashSolutionsProvince.value) {
                case "Gauteng":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Eastern Cape":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Free State":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Kwazulu Natal":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Limpopo":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Mpumalanga":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "North West":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Northern Cape":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Western Cape":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                default:
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
            }
        }
    };
    FormItemBusinessCashSolutionsV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _product = this.form.querySelector("input[name=product]");
        var _subject = this.form.querySelector("input[name=subject]");
        var _recipient = this.form.querySelector("input[name=recipient]");
        var _email = this.form.querySelector("input[name=email]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _phoneNumber = this.form.querySelector("input[name=phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _companyName = this.form.querySelector("input[name=company-name]");
        var _province = this.form.querySelector("select[name=province]");
        var _isSBCustomer = this.isSBCustomerValue;
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _postData = {
            'product': (_product ? _product.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'email': (_email ? _email.value : ""),
            'first-name': (_firstname ? _firstname.value : ""),
            'last-name': (_lastName ? _lastName.value : ""),
            'phone-number': (_phoneNumber ? _phoneNumber.value : ""),
            'email-address': (_emailAddress ? _emailAddress.value : ""),
            'company-name': (_companyName ? _companyName.value : ""),
            'province': (_province ? _province.value : ""),
            'banking-with-standard-bank': (_isSBCustomer ? _isSBCustomer : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            dataSharingWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(this.form, 'data-sharing-group'),
            dataSharingWithThirdPartiesMarketingConsent: this.dataConsentService.getDataConsentValue(this.form, 'data-sharing-3rd-party'),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(this.form, 'data-sharing-boarders'),
        };
        this.showDisplayView("loader");
        // variables
        var url = "/sites/services/CashSolutionsForm.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (pResponse) {
            // service ok
            if (!pResponse) {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
                _this.showDisplayView("error");
            }
            else if (pResponse.data) {
                if (pResponse.data.toString().toLowerCase().includes("invalid")) {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                    _this.showDisplayView("error");
                }
                else {
                    _this.analyticsService.dtmFormComplete('complete', pResponse.data);
                    _this.showDisplayView("success");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.showDisplayView("error");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    // -- CUSTOM BUSINESS CASH SOLUTIONS VALIDATIONS -- //
    FormItemBusinessCashSolutionsV2.prototype.businessCashSolutionsValidations = function () {
        var radioDetailsErrorDetails = "This field is required";
        var validationErrors = false;
        // Radio Details Selection Error
        var isSBCustomerSelectionGroup = this.isSBCustomer[0].closest(".form__group");
        // Buy Own Details Selection Error
        if (!isSBCustomerSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.isSBCustomerValue === "") {
                validationErrors = true;
                isSBCustomerSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                isSBCustomerSelectionGroup.appendChild(_errorDiv);
            }
        }
    };
    FormItemBusinessCashSolutionsV2.prototype.resetForm = function () {
        this.isSBCustomerValue = '';
    };
    FormItemBusinessCashSolutionsV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemBusinessCashSolutionsV2;
}(Base));
export { FormItemBusinessCashSolutionsV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-cash-solutions-v2/form-item-business-cash-solutions-v2.component.ts
// module id = 855
// module chunks = 0